import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../store/auth';
import { startUserStream, stopUserStream } from '../lib/userStream';

export function RealtimeBridge() {
  const token = useAuth((s) => s.token);
  const qc = useQueryClient();

  useEffect(() => {
    if (!token) return;
    startUserStream(qc);
    return () => stopUserStream();
  }, [token, qc]);

  return null;
}
